import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from '../store';
import axios from '../utils/APIUtils';
import { PROFILES_API_PATHS } from '../constants/constants';
import IOnBoardingStatusItemModal from '../models/IOnBoardingModal';
import { GenericState } from './ISliceInterfaces';
import { UserManager } from '@forge/sso-client';
import { isAks } from 'src/utils/properties/UrlsAndEnvProperties';

 
// COMMENT: menu sample json
const menus = [
  {
    name: 'overview',
    display_text: 'Overview',
  },
  {
    name: 'anomalies',
    display_text: 'Anomalies',
  },
  // {
  //   name: 'sample',
  //   display_text: 'Sample',
  // },
  {
    name: 'unassigned_anomalies',
    display_text: 'Unassigned Anomalies',
  },
  {
    name: 'add_context',
    display_text: 'Add Context',
  },
  // {
  //   name: 'landing_page',
  //   display_text: 'Landing Page',
  // },

  //Disabling DATA GPT and CAMS GPT
  // {
  //   name: 'data_gpt',
  //   display_text: 'Data GPT',
  // },
  // {
  //   name: 'cams_gpt',
  //   display_text: 'CAMS GPT',
  // },

  // {
  //   name: 'new_rule_creation',
  //   display_text: 'New Rule Creation',
  // },
  {
    name: 'model_review',
    display_text: 'Model Review',
  },
  {
    name: 'metric_dashboard',
    display_text: 'Metric Dashboard ',
  },
];

 

export const initialState = {
  onBoardingData: {
    status: 'idle',
  } as GenericState<IOnBoardingStatusItemModal>,
  isDeepLink: false,
  currentRole: '' as any,
  guideTour:'' as any,
  configStatus: 'idle',
  config: {
    message: 'en.json',
    controlCenterURL: '',
    geoJsonURL: '',
    menus: [],
  }
};

const getActiveRole  = (state:RootState) => {
  if(state!==null && state.onBoarding!==null && 
      state.onBoarding.currentRole === sessionStorage.getItem("role")){
    return state.onBoarding.currentRole
  }
  else{
    const role = sessionStorage.getItem("role");
      return role !== null && role !== undefined? role : ''
  }
} 

export const getOnBoardingStatus = createAsyncThunk(
  'onBoarding/getOnBoardingStatus',
  async (_, { dispatch }) => {
    const userManager = UserManager.getInstance();
    const user = await userManager.getUser();
    const response = await axios.get<IOnBoardingStatusItemModal>(
      PROFILES_API_PATHS.onBoarding,
      {
        headers: {
          'x-id-token': `Bearer ${
            isAks() ? sessionStorage.getItem('idToken') : user?.id_token
          }`,
        },
      }
    );
    await dispatch(getConfig());
    return response.data;
  }
);
 

export const getConfig = createAsyncThunk('onBoarding/getConfig', async () => {
  const response = await axios.get(PROFILES_API_PATHS.config);
  return response.data;
});

export const updatePrivacyNoticeStatus = createAsyncThunk('onBoarding/updatePrivacyNotice', async (userresponse: any) => {
  const response = await axios.post(PROFILES_API_PATHS.updatePrivacyNotice, userresponse);
  return response.data;
});

 

export const onBoardingSlice = createSlice({
  name: 'onBoarding',
  initialState,
  reducers: {
    setIsDeepLinkStatus: (state, action) => {
      state.isDeepLink = action.payload;
    },
    setCurrentRole: (state, action) => {
      state.currentRole = action.payload;
      sessionStorage.setItem("role", action.payload) 
    },
    setConfigMessage: (state, { payload: message }) => {
      return { ...state, config: { ...state.config, message } };
    },
    setGuideTour: (state, action) => {
      state.guideTour = action.payload;
      sessionStorage.setItem("guideTour", action.payload) 
    },
  },

 

  extraReducers: (builder) => {
    builder.addCase(getOnBoardingStatus.pending, (state) => {
      state.onBoardingData.status = 'loading';
    });
    builder.addCase(getOnBoardingStatus.fulfilled, (state, action) => {
      state.onBoardingData.status = 'finished';
      state.onBoardingData.data = action.payload;
    });
    builder.addCase(getOnBoardingStatus.rejected, (state) => {
      state.onBoardingData.status = 'error';
    });
    builder.addCase(getConfig.pending, (state) => {
      return { ...state, configStatus: 'loading' };
    });
    builder.addCase(getConfig.fulfilled, (state, { payload: config }) => {
      return {
        ...state,
        configStatus: 'finished',
        config: { ...state.config, ...config },
      };
    });
    builder.addCase(getConfig.rejected, (state) => {
      return {
        ...state,
        configStatus: 'error',
        onBoardingData: { ...state.onBoardingData, status: 'error' },
      };
    });
  },
});

 

export const { setIsDeepLinkStatus, setCurrentRole, setConfigMessage,setGuideTour } =
  onBoardingSlice.actions;

 

export const getOnBoardingAPIData = (state: RootState) =>
  state.onBoarding.onBoardingData.data;

 

export const getOnBoardingAPIStatus = (state: RootState) =>
  state.onBoarding.onBoardingData.status;

 

export const getDeepLinkStatus = (state: RootState) =>
  state.onBoarding.isDeepLink;

 
export const getGuideTour = (state: RootState) =>
  state.onBoarding.guideTour;

export const getCurrentRole = (state: RootState) =>
  // state.onBoarding.currentRole != ''? state.onBoarding.currentRole : sessionStorage.getItem('role')
   getActiveRole(state)
  // console.log(state.onBoarding.currentRole = (state))

 

export const getConfigData = (state: RootState) => state.onBoarding.config;
export const getConfigStatus = (state: RootState) =>
  state.onBoarding.configStatus;

 

export const getConfigMsg = (state: RootState) =>
  getConfigData(state)?.message || 'en.json';

 

export const getMenuList = (state: RootState) => menus;
// getConfigData(state)?.menus || [];

export const getPrivacyNoticeStatus = (state: RootState) => {
  return state.onBoarding.onBoardingData.data?.isprivacynoteaccepted
}


//get domain details
export const getDomainDetails = (state: RootState) => 
  state.onBoarding.onBoardingData.data?.domains? state.onBoarding.onBoardingData.data?.domains : []

export const getAllDomainDetails = (state: RootState) => 
state.onBoarding.onBoardingData.data?.all_domains? state.onBoarding.onBoardingData.data?.all_domains : []

export default onBoardingSlice.reducer;